/**
 * BBS Live Personalization Preview
 * Product: Ballpark Brew Personalized Beer Mug (/products/personalized-baseball-beer-mug)
 *
 * Finds the personalization input, shows a styled live preview panel,
 * and overlays the text onto the product's main image in real-time.
 */
(function () {
  'use strict';

  // Only run on the beer mug product page
  if (!window.location.pathname.includes('personalized-baseball-beer-mug')) return;

  // ─── Config ──────────────────────────────────────────────────────────────────
  var PREVIEW_FONT   = '"Georgia", "Times New Roman", serif';
  var PREVIEW_COLOR  = '#1a1a1a';
  var OVERLAY_BOTTOM = '30%';   // vertical position on the mug image — fine-tune after first preview
  var OVERLAY_LEFT   = '50%';

  // ─── Selectors (ordered most-to-least specific) ────────────────────────────
  var INPUT_SELECTORS = [
    'input[name="properties[Personalization]"]',
    'input[name="properties[Name]"]',
    'input[name="properties[Custom Text]"]',
    'textarea[name^="properties["]',
    'input[id*="personali" i]',
    'input[placeholder*="personali" i]',
    'input[placeholder*="name" i]',
    'textarea[placeholder*="personali" i]',
  ];

  var IMAGE_SELECTORS = [
    '.product__media img',
    '.product-single__photo img',
    '.product__photo img',
    '[data-product-featured-image]',
    '.product-image-main img',
    '.featured-image img',
    'img[itemprop="image"]',
  ];

  var IMAGE_WRAPPER_SELECTORS = [
    '.product__media-wrapper',
    '.product__media',
    '.product-single__photo-wrapper',
    '.product__photo-wrapper',
    '.product-image-main',
    '.product__images',
  ];

  // ─── Helpers ─────────────────────────────────────────────────────────────────
  function querySelector(selectors, context) {
    context = context || document;
    for (var i = 0; i < selectors.length; i++) {
      var el = context.querySelector(selectors[i]);
      if (el) return el;
    }
    return null;
  }

  // ─── Overlay (on product image) ────────────────────────────────────────────
  function createImageOverlay(wrapper) {
    var existing = getComputedStyle(wrapper).position;
    if (!existing || existing === 'static') wrapper.style.position = 'relative';

    var overlay = document.createElement('div');
    overlay.id = 'bbs-img-overlay';
    overlay.setAttribute('aria-hidden', 'true');
    overlay.style.cssText = [
      'position:absolute',
      'bottom:' + OVERLAY_BOTTOM,
      'left:' + OVERLAY_LEFT,
      'transform:translateX(-50%)',
      'font-family:' + PREVIEW_FONT,
      'font-size:clamp(13px,2.8vw,21px)',
      'font-weight:bold',
      'color:' + PREVIEW_COLOR,
      'text-align:center',
      'white-space:nowrap',
      'max-width:55%',
      'overflow:hidden',
      'text-overflow:ellipsis',
      'pointer-events:none',
      'opacity:0',
      'transition:opacity 0.2s ease',
      'z-index:10',
      'letter-spacing:0.04em',
      'text-shadow:0 1px 2px rgba(255,255,255,0.5)',
    ].join(';');

    wrapper.appendChild(overlay);
    return overlay;
  }

  // ─── Preview Panel (always reliable, sits below the input) ─────────────────
  function createPreviewPanel(input) {
    var panel = document.createElement('div');
    panel.id = 'bbs-preview-panel';
    panel.style.cssText = [
      'margin:10px 0 6px',
      'padding:14px 18px',
      'background:#f4f6f8',
      'border-radius:8px',
      'border:1px dashed #bcc5d0',
      'text-align:center',
      'display:none',
    ].join(';');

    var label = document.createElement('p');
    label.textContent = 'Preview — how it will look on your mug:';
    label.style.cssText = 'font-size:11px;color:#888;margin:0 0 8px;text-transform:uppercase;letter-spacing:0.06em;';

    var text = document.createElement('p');
    text.id = 'bbs-preview-text';
    text.style.cssText = [
      'font-family:' + PREVIEW_FONT,
      'font-size:clamp(16px,4vw,26px)',
      'font-weight:bold',
      'color:' + PREVIEW_COLOR,
      'margin:0',
      'letter-spacing:0.05em',
    ].join(';');

    panel.appendChild(label);
    panel.appendChild(text);
    input.parentNode.insertBefore(panel, input.nextSibling);
    return panel;
  }

  // ─── Update both preview surfaces ─────────────────────────────────────────
  function updatePreviews(rawValue, panel, previewText, imgOverlay) {
    // Strip "Name:" style labels that some personalization instructions suggest
    var display = rawValue.replace(/^(name|#|number|team)\s*:\s*/i, '').trim();

    // Preview panel
    if (display) {
      previewText.textContent = display;
      panel.style.display = 'block';
    } else {
      panel.style.display = 'none';
    }

    // Image overlay
    if (imgOverlay) {
      imgOverlay.textContent = display;
      imgOverlay.style.opacity = display ? '1' : '0';
    }
  }

  // ─── Init ─────────────────────────────────────────────────────────────────
  function init() {
    var input = querySelector(INPUT_SELECTORS);
    if (!input) {
      // Last-resort: any visible text/number input inside the product form
      var form = document.querySelector('form[action*="/cart/add"]');
      if (form) {
        input = form.querySelector('input[type="text"], input[type="number"], textarea');
      }
    }
    if (!input) return; // no personalization field found — bail silently

    var panel = createPreviewPanel(input);
    var previewText = document.getElementById('bbs-preview-text');

    // Optional image overlay (best-effort, won't break if image not found)
    var imgWrapper = querySelector(IMAGE_WRAPPER_SELECTORS);
    var imgOverlay = imgWrapper ? createImageOverlay(imgWrapper) : null;

    input.addEventListener('input', function () {
      updatePreviews(input.value, panel, previewText, imgOverlay);
    });

    // Populate from any default value
    if (input.value) updatePreviews(input.value, panel, previewText, imgOverlay);
  }

  // Wait for DOM + Shopify theme JS to finish
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(init, 150); });
  } else {
    setTimeout(init, 150);
  }
})();
